import React from "react";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import EstimateProjectForm from "../../WebDevelopmentPage/EstimateProjectForm";

const highlights = [
  {
    title: "Functional Testing",
    description: "Verify every feature responds correctly with input/output validation.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <rect x="4" y="4" width="16" height="16" rx="3" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    title: "Performance Testing",
    description: "Measure speed, scalability, and stability under real-world load.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 18V8M4 18h16M8 14V11M12 14V6M16 14V9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Regression Testing",
    description: "Ensure new changes never break existing working functionality.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 12a8 8 0 0 1 13.5-5.7M20 12a8 8 0 0 1-13.5 5.7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M17 4v4h-4M7 20v-4h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: "Mobile Testing",
    description: "Validate apps across Android, iOS, and every screen size.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="7" y="2" width="10" height="20" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M11 18h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
];

const StestIntroSection: React.FC = () => {
  return (
    <section className="wdev-intro" aria-labelledby="stest-intro-title">
      <div className="container">
        <div className="wdev-intro__grid">
          <AnimatedSection className="wdev-intro__content">
            <span className="wdev-label wdev-label--purple">Quality Assurance</span>
            <h2 id="stest-intro-title" className="wdev-intro__title">
              Top Functional Testing Company in Bangalore
            </h2>

            <p className="wdev-intro__text">
              Functional testing is the verification and validation of each function
              of a software application. With our testing expertise, WebTech Software
              Solutions is one of the top software functional testing companies in
              Bangalore — ensuring quality and stability before your product reaches users.
            </p>
            <p className="wdev-intro__text">
              Testing answers whether a task can be performed and whether each feature
              responds properly. It minimizes risk, builds customer trust, and helps
              maintain the reputation your business depends on. Functions are tested by
              providing input and examining output — focused on results, not just process.
            </p>

            <div className="wdev-intro__highlights">
              {highlights.map((item) => (
                <div className="wdev-intro__highlight" key={item.title}>
                  <div className="wdev-intro__highlight-icon">{item.icon}</div>
                  <div>
                    <h3 className="wdev-intro__highlight-title">{item.title}</h3>
                    <p className="wdev-intro__highlight-desc">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </AnimatedSection>

          <AnimatedSection className="wdev-intro__form-wrap" delay={0.15}>
            <EstimateProjectForm />
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default StestIntroSection;
